import { baseUrl } from '../../../network'

//company labels
export const createLabelUrl = (companyId: number) => baseUrl + `api/company/${companyId}/labels` 
export const deleteLabelUrl = (labelId: number) => baseUrl + `api/company/labels/${labelId}` 
